import { render } from "./PromotionalSMS.vue?vue&type=template&id=42da527c&scoped=true&ts=true"
import script from "./PromotionalSMS.vue?vue&type=script&lang=ts"
export * from "./PromotionalSMS.vue?vue&type=script&lang=ts"

import "./PromotionalSMS.vue?vue&type=style&index=0&id=42da527c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42da527c"]])

export default __exports__